import gql from "graphql-tag";

export const EMAIL_COMMUNICATIONS = gql`
  query user($userId: ID!) {
    user(id: $userId) {
      id
      userEmailCommunications {
        id
        sgTemplateName
        event
        timestamp
      }
    }
  }
`;

export const CLIENT_BADGES = gql`
  query user($userId: ID!) {
    user(id: $userId) {
      id
      userbadgeSet {
        id
        createdAt
        coachComment
        awardedBy {
          firstName
          lastName
        }
        badge {
          id
          title
        }
      }
    }
  }
`;

export const CLIENT_ACTIVITIES_QUERY = gql`
  query activitiesQuery($userId: ID) {
    activities(userId: $userId, first: 40) {
      edges {
        node {
          id
          effort
          calories
          heartRate
          startDate
          seconds
          distance
          isCustom
          activityType
          type {
            id
            name
            category
          }
          guidedRun {
            id
            name
            published
          }
          event {
            id
            name
            eventType {
              id
              name
              category
            }
          }
          action {
            workout {
              id
              name
              label
              workoutProgram {
                id
              }
            }
          }
          workout {
            id
            name
            label
            workoutProgram {
              id
            }
          }
        }
      }
    }
  }
`;

export const NUTRITION_LOG_DETAIL_QUERY = gql`
  query nutritionQuery($userId: ID) {
    nutritionLog(userId: $userId, last: 40) {
      edges {
        node {
          id
          date
          comments
          coachComment
          isNutritiousDay
          totalQuestions
          truthyQuestions
          createdAt
          usernutritionloganswerSet {
            id
            answer
            nutritionQuestion {
              id
              question
              title
            }
          }
        }
      }
    }
  }
`;
